<template>
  <div class="qw-login-box">
    <div class="bind">
      <span class="bind_span">企业微信：{{ user.id_card ? '已绑定' : '未绑定' }}</span>
      <svg class="icon svg-icon" aria-hidden="true" width="25" height="25" @click="qwLogin">
        <use :xlink:href="user.id_card ? '#youkai-qiyeweixin' : '#youkai-qiyeweixin1'"></use>
      </svg>
    </div>
    <div class="ddLogin-back" v-show="qwLoginShow" @click="closeDdLogin"></div>
    <div id="ww_login" v-show="qwLoginShow"></div>
  </div>
</template>

<script>
import * as ww from '@wecom/jssdk'
export default {
  name: 'QwQrcodeLogin',
  props: {
    user: Object
  },
  data () {
    return {
      qwLoginShow: false,
      wwLogin: null
    }
  },
  methods: {
    qwLogin () {
      this.qwLoginShow = true
    },
    closeDdLogin () {
      this.qwLoginShow = false
    },
    qwInit () {
      const location = window.location
      let _that = this
      this.wwLogin = ww.createWWLoginPanel({
        el: '#ww_login',
        params: {
          login_type: 'CorpApp',
          appid: 'ww5e54fc9b3c32d2ab',
          agentid: '1000049',
          redirect_uri: `${location.protocol}//${location.host}`,
          state: 'qyh',
          redirect_type: 'callback',
          panel_size: 'small'
        },
        onCheckWeComLogin ({ isWeComLogin }) {
          console.log('企业微信', isWeComLogin)
        },
        onLoginSuccess ({ code }) {
          _that.qwLoginCode(code, _that.user.id)
        },
        onLoginFail (err) {
          console.log(err)
        }
      })
    },
    qwLoginCode (code, userId) {
      this.$axios.post('/api/admin/qwLogin/bind', { code, userId })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.user.id_card = data.data.id_card
            this.$emit('updateUser', this.user)
            this.qwLoginShow = false
            this.wwLogin.unmount()
            this.qwInit()
            this.$message.success(data.msg)
          } else {
            this.qwLoginShow = false
            this.wwLogin.unmount()
            this.qwInit()
            this.$message.error(data.msg)
          }
        })
    }
  },
  mounted () {
    this.qwInit()
    console.log(this.user)
  }
}
</script>

<style lang="stylus" scoped>
.bind {
  display: flex;
}
.bind svg {
  cursor: pointer;
}
.bind_span {
  line-height: 25px;
  margin-right: 5px;
}
#ww_login
  position: fixed
  top: 40%
  left: 51.5%
  width: 320px
  margin-top: -113.5px
  margin-left: -222px
  background: #fff
  z-index: 99999
.ddLogin-back
  width: 100%
  height: 100%
  background: #000
  opacity: 0.5
  position: fixed
  left: 0
  top: 0
  z-index: 99998
</style>



// WEBPACK FOOTER //
// src/pages/authority/common/QwQrcodeLogin.vue